import { Erro } from "../StatusIcones/erro";
import { Finalizado } from "../StatusIcones/finalizado";
import { Indisponivel } from "../StatusIcones/indisponivel";
import { Lupa } from "../StatusIcones/lupa";
import { Play } from "../StatusIcones/play";
import { Processando } from "../StatusIcones/processando";
import { EtapaGerenciarEmplacamentosEnum } from "../../enums/EtapaGerenciarEmplacamentos.enum";
import { EtapaAuxiliarGerenciarEmplacamentosEnum } from "../../enums/EtapaAuxiliarGerenciarEmplacamentos.enum";
import { StatusEtapaGerenciarEmplacamentosEnum } from "../../enums/StatusEtapaGerenciarEmplacamentos.enum";
import { HttpResponse } from "_services/api/HttpResponse";
import { IListarEmplacamentosPR } from "../../Interfaces/IListarEmplacamentosPR";

interface HandleStatusApropriarProcessoProps {
  etapa: EtapaGerenciarEmplacamentosEnum;
  etapaAuxiliar: EtapaAuxiliarGerenciarEmplacamentosEnum | null;
  status: StatusEtapaGerenciarEmplacamentosEnum;
  apropriarProcesso: (id: number) => Promise<HttpResponse>;
  idProcesso: number;
  dados: IListarEmplacamentosPR[];
  setDados: (dados: IListarEmplacamentosPR[]) => void;
  setTooltipLeft: (left: number) => void;
  setTooltipTop: (top: number) => void;
  setTooltipConteudo: (conteudo: string | JSX.Element) => void;
  setTooltipWidth: (width: number) => void;
  setShowTooltip: (show: boolean) => void;
  abrirModalPularProximaEtapa: (
    id: number,
    mensagemErro: string,
    etapaComErro: EtapaGerenciarEmplacamentosEnum
  ) => void;
  mensagemErro: string;
  codigoDeBarras: NullableString;
  listar: () => void;
}
export function HandleStatusApropriarProcesso({
  etapa,
  etapaAuxiliar,
  status,
  apropriarProcesso,
  idProcesso,
  dados,
  setDados,
  setTooltipLeft,
  setTooltipTop,
  setTooltipConteudo,
  setTooltipWidth,
  setShowTooltip,
  abrirModalPularProximaEtapa,
  mensagemErro,
  codigoDeBarras,
  listar,
}: HandleStatusApropriarProcessoProps) {
  const handleStatus = (
    status: StatusEtapaGerenciarEmplacamentosEnum,
    mensagem?: string
  ) => {
    dados.forEach((processo) => {
      if (processo.id == idProcesso) {
        processo.statusEtapa = status;
        processo.etapa = EtapaGerenciarEmplacamentosEnum.APROPRIAR_PROCESSO;

        if (mensagem) {
          processo.observacao = mensagem;
        }
      }
    });
    setDados(dados);
  };

  const onClick = async () => {
    handleStatus(StatusEtapaGerenciarEmplacamentosEnum.PROCESSANDO);
    setDados([...dados]);
    const { hasErro, data } = await apropriarProcesso(idProcesso);

    setShowTooltip(false);
    setTooltipLeft(0);
    setTooltipTop(0);
    setTooltipConteudo("");

    if (hasErro) {
      handleStatus(
        StatusEtapaGerenciarEmplacamentosEnum.ERRO,
        data?.message ?? null
      );
      return;
    }

    if (data?.recarregar) {
      await listar();
      return;
    }

    handleStatus(StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO);
  };

  const etapasPosteriores = [
    EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA,
    EtapaGerenciarEmplacamentosEnum.EMITIR_LICENCIAMENTO,
    EtapaGerenciarEmplacamentosEnum.SOLICITAR_PLACA,
    EtapaGerenciarEmplacamentosEnum.FINALIZAR_PROCESSO,
  ];

  const etapasMuitoAnteriores = [
    EtapaGerenciarEmplacamentosEnum.ESCOLHER_PLACA,
    EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO,
    EtapaGerenciarEmplacamentosEnum.PAGAR_TAXA
  ];

  if (
    !codigoDeBarras ||
    !etapa ||
    (etapa == EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO_DIGITAL &&
      status != StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO) ||
    etapasMuitoAnteriores.includes(etapa)
  ) {
    return <Indisponivel />;
  }

  if (
    (etapa && etapasPosteriores.includes(etapa)) ||
    (etapa == EtapaGerenciarEmplacamentosEnum.APROPRIAR_PROCESSO &&
      status == StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO)
  ) {
    return <Finalizado />;
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.APROPRIAR_PROCESSO &&
    status == StatusEtapaGerenciarEmplacamentosEnum.ERRO
  ) {
    return (
      <Erro
        onClick={() =>
          abrirModalPularProximaEtapa(
            idProcesso,
            mensagemErro,
            EtapaGerenciarEmplacamentosEnum.APROPRIAR_PROCESSO
          )
        }
      />
    );
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.APROPRIAR_PROCESSO &&
    status == StatusEtapaGerenciarEmplacamentosEnum.PROCESSANDO
  ) {
    return (
      <Processando
        setTooltipLeft={setTooltipLeft}
        setTooltipTop={setTooltipTop}
        setTooltipConteudo={setTooltipConteudo}
        setTooltipWidth={setTooltipWidth}
        setShowTooltip={setShowTooltip}
      />
    );
  }

  const etapa_com_pendencia = [EtapaAuxiliarGerenciarEmplacamentosEnum.CONSULTAR, EtapaAuxiliarGerenciarEmplacamentosEnum.INDEFERIDO];
  if (etapa_com_pendencia.includes(etapaAuxiliar as EtapaAuxiliarGerenciarEmplacamentosEnum)) {
    return (
      <Lupa
        acao={onClick}
        setTooltipLeft={setTooltipLeft}
        setTooltipTop={setTooltipTop}
        setTooltipConteudo={setTooltipConteudo}
        setTooltipWidth={setTooltipWidth}
        setShowTooltip={setShowTooltip}
        mensagemTooltip={`${etapaAuxiliar === EtapaAuxiliarGerenciarEmplacamentosEnum.CONSULTAR ? "Pendente" : "Indeferido"}`}
        color={`${etapaAuxiliar === EtapaAuxiliarGerenciarEmplacamentosEnum.CONSULTAR ? "#000" : "#d36f2cf8"}`}
      />
    );
  }

  return <Play acao={onClick} />;
}
